import { Reveal, Eyebrow } from "./Reveal";

const steps = [
  ["01", "Pick your produce", "Choose a box and any extras you'd like, and tell us where to drop them."],
  ["02", "Pay by online banking", "You'll get an order reference. Transfer the total from your bank using that reference."],
  ["03", "We pack & deliver", "Once payment lands, we pack your box with fresh seasonal produce and bring it to your door."],
];

export const HowItWorks = () => (
  <section id="how" className="mx-auto max-w-[1440px] px-5 py-24 sm:px-10 md:py-36" data-testid="how-section">
    <div className="grid gap-12 lg:grid-cols-12">
      <Reveal className="lg:col-span-4">
        <Eyebrow>How it works</Eyebrow>
        <h2 className="mt-5 font-display text-4xl font-extrabold leading-[0.95] tracking-tight sm:text-5xl">
          Three steps from paddock to porch.
        </h2>
      </Reveal>
      <div className="lg:col-span-8">
        {steps.map(([n, t, d], i) => (
          <Reveal key={n} delay={i * 0.1}>
            <div className="group grid grid-cols-[auto_1fr] gap-6 border-t border-white/10 py-9 sm:grid-cols-[140px_1fr_1fr] sm:gap-10" data-testid={`how-step-${n}`}>
              <span className="font-display text-5xl font-extrabold text-outline transition-colors duration-500 group-hover:text-[var(--gold)] sm:text-7xl">{n}</span>
              <h3 className="self-center font-display text-2xl font-bold tracking-tight sm:text-3xl">{t}</h3>
              <p className="col-span-2 self-center text-[var(--sage)] sm:col-span-1">{d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
